//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/other/Button'
import LeftAside from '~/components/other/LeftAside'
import SidebarAnchors from '~/components/other/SidebarAnchors'
import FaqItems from '~/components/faq/FaqItems'
import MtModal from '~/components/Modal/MtModal'

const groupQuestions = (list) => {
  return list.reduce((res, item) => {
    let group = res.find((g) => g.query === item.query)

    if (!group) {
      group = {
        query: item.query,
        mir: /«Мир»/.test(item.query) || / Mir /.test(item.query),
        items: []
      }

      res = [...res, group]
    }

    group.items = [
      ...group.items,
      {
        id: item.id,
        name: item.name,
        answer: item.answer
      }
    ]

    return res
  }, [])
}

export default {
  components: {
    MtModal,
    Button,
    LeftAside,
    SidebarAnchors,
    FaqItems
  },
  data () {
    return {
      addMasterpieceOpened: false,
      showFaqModal: false
    }
  },
  computed: {
    questions () {
      if (!this.$chimera.faq.data) {
        return []
      }
      return groupQuestions(this.$chimera.faq.data.data) || []
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    getForm() {
      const url = this.isEn ? 'https://crm.tretyakov.ru/upload/crm/form/loader_158_ivyu51.js' : 'https://crm.tretyakov.ru/upload/crm/form/loader_75_tweb70.js'
      return `(function(w,d,u){
		var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
		var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
	})(window,document,'${url}');`
    }
  },
  methods: {
    closeQuestionForm () {
      this.showFaqModal = false;
      if (window && window.b24form && window.b24form.forms) {
        window.b24form.forms = null
      }
    }
  },
  head() {
    const seo = this.getSeo?.data?.data || {}
    let title = seo.title
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }
    return {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords }
      ]
    }
  },
  chimera: {
    getSeo () {
      return {
        url: `/api/v1/seo/getByCode`,
        key: `page-seo-faq-${this.$i18n.locale || 'ru'}`,
        params: {
          code: 'faq',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    faq () {
      return {
        url: '/api/v1/faq/get/',
        key: `faq-list-${this.$i18n.locale || 'ru'}`,
        auto: true,
        params: {
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
